import React from 'react';
import { Button, Col, Form, message, Modal, Row, Skeleton } from 'antd';

import { useFetchConstant } from 'apis/constant';

import FormInput from 'components/FormInput/FormInput';
import FormSelection from 'components/FormSelection/FormSelection';

const { useForm } = Form;
const { confirm } = Modal;

const AddNomineeModal = ({ defaultValues, onOk, onClose, onRemove, visible }) => {
  const [form] = useForm();
  const { isLoading: isNominationTypesLoading, selection: nominationTypes } = useFetchConstant('nominationTypes');
  const { isLoading: isRelationshipsLoading, selection: relationships } = useFetchConstant('relationships');
  const isConstantsLoading = isNominationTypesLoading || isRelationshipsLoading;

  const handleOnOkButtonClick = async e => {
    e.preventDefault();
    try {
      const values = await form.validateFields();
      onOk(values);
    } catch (error) {
      error.errorFields.forEach(field => message.error(field.errors[0]));
    }
  };

  const handleOnRemoveButtonClick = () => {
    confirm({
      title: 'Do you want to remove this from the list?',
      okText: 'Yes',
      onOk() {
        onRemove();
      },
      onClose() {}
    });
  };

  const footer = defaultValues
    ? [
        <Button key="remove" onClick={handleOnRemoveButtonClick}>
          Remove
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          Save this nominee
        </Button>
      ]
    : [
        <Button key="cancel" onClick={onClose}>
          Cancel
        </Button>,
        <Button key="submit" type="primary" onClick={handleOnOkButtonClick}>
          Add new nominee
        </Button>
      ];

  return (
    <Modal title="Nominee Details" visible={visible} onOk={handleOnOkButtonClick} onCancel={onClose} footer={footer} width="60%">
      <Form form={form} initialValues={defaultValues}>
        {isConstantsLoading ? (
          <Skeleton active />
        ) : (
          <>
            <Row gutter={16}>
              <Col span={24}>
                <FormInput label="Name" name="name" placeholder="Joe Doe" requiredErrorMessage="Please enter name of nominee." />
              </Col>
              <Col span={12}>
                <FormSelection
                  label="Relationship"
                  name="relationship"
                  placeholder="Child"
                  requiredErrorMessage="Please select relationship of this nominee to advisee."
                  selections={relationships}
                />
              </Col>
              <Col span={12}>
                <FormSelection
                  label="Nominee Type"
                  name="type"
                  placeholder="Beneficiary"
                  requiredErrorMessage="Please select a type of this nominee."
                  selections={nominationTypes}
                />
              </Col>
            </Row>
          </>
        )}
      </Form>
    </Modal>
  );
};

export default AddNomineeModal;
